export default "__VITE_ASSET__l1IrV$25__"